import { QueryBuilderAstNodeType, QueryBuilderTokenType } from '../../../../../../types';

const nodeToTokens = (node: QueryBuilderAstNodeType): QueryBuilderTokenType[] => {
  if (node.type === 'condition') {
    return [
      {
        type: 'entityValue',
        entityKey: node.entityKey,
        value: node.value,
      },
    ];
  }

  const childTokenGroups = node.children.map((child) => {
    const childTokens = nodeToTokens(child);

    if (child.type === 'group') {
      return [
        { type: 'bracket', bracket: 'OPEN' },
        ...childTokens,
        { type: 'bracket', bracket: 'CLOSE' },
      ] satisfies QueryBuilderTokenType[];
    }

    return childTokens;
  });

  return childTokenGroups.reduce<QueryBuilderTokenType[]>((tokens, group, index) => {
    if (index > 0) {
      tokens.push({ type: 'operator', operator: node.operator });
    }

    tokens.push(...group);
    return tokens;
  }, []);
};

export const astToTokens = (
  ast: QueryBuilderAstNodeType
): QueryBuilderTokenType[] => nodeToTokens(ast);
